import MedicalHistoryEnums from '../utils/enums'
import MedicalHistoryFormTemplates from '../utils/templates'
import store from '../../../../store'
import { message } from 'antd'
import { createItemWithSync, getDataWithSync, updateItemWithSync } from '../../../../db/dbSync'
import { STORES } from '../../../../db/indexedDB'

export const getPatMedicalHistory = () => {
  const userRef = store.getState().auth.agiliteUser?._id
  return new Promise((resolve, reject) => {
    ;(async () => {
      try {
        const qry = { userRef: userRef }
        let response = null

        response = await getDataWithSync(STORES.MEDICAL_HISTORY, {
          body: {
            filter: JSON.stringify(qry),
            page: null,
            pageLimit: null
          },
          requestConfig: {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'profile-key': MedicalHistoryEnums.profileKeys.PATIENTS,
              'route-key': MedicalHistoryEnums.routeKeys.READ
            }
          }
        })

        if (response.length > 0) {
          resolve(response[0])
        } else {
          response = await createMedicalHistory({
            userRef: store.getState().auth.agiliteUser._id,
            medicalHistory: MedicalHistoryFormTemplates.dataTemplate
          })

          resolve(response)
        }
      } catch (e) {
        reject(e)
      }
    })()
  })
}

export const createMedicalHistory = (data) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      try {
        const response = await createItemWithSync(STORES.MEDICAL_HISTORY, {
          body: {
            data: JSON.stringify(data)
          },
          requestConfig: {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'profile-key': MedicalHistoryEnums.profileKeys.PATIENTS,
              'route-key': MedicalHistoryEnums.routeKeys.CREATE
            }
          }
        })

        resolve(response)
      } catch (e) {
        reject(e)
      }
    })()
  })
}

export const updateAllergies = (recordId, data) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      try {
        const response = await updateItemWithSync(STORES.MEDICAL_HISTORY, {
          _id: recordId,
          body: {
            recordId,
            data: JSON.stringify({ allergies: { ...data, updatedAt: new Date() } })
          },
          requestConfig: {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'profile-key': MedicalHistoryEnums.profileKeys.PATIENTS,
              'route-key': MedicalHistoryEnums.routeKeys.UPDATE_ONE
            }
          }
        })

        resolve(response)
        message.success('Allergies updated successfully')
      } catch (e) {
        reject(e)
      }
    })()
  })
}

export const updateChronicIllnesses = (recordId, data) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      try {
        const response = await updateItemWithSync(STORES.MEDICAL_HISTORY, {
          _id: recordId,
          body: {
            recordId,
            data: JSON.stringify({ chronicIllnesses: { updatedAt: new Date(), list: data } })
          },
          requestConfig: {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'profile-key': MedicalHistoryEnums.profileKeys.PATIENTS,
              'route-key': MedicalHistoryEnums.routeKeys.UPDATE_ONE
            }
          }
        })

        resolve(response)
        message.success('Chronic illnesses updated successfully')
      } catch (e) {
        reject(e)
      }
    })()
  })
}

export const updateGeneralMeds = (recordId, data) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      try {
        const response = await updateItemWithSync(STORES.MEDICAL_HISTORY, {
          _id: recordId,
          body: {
            recordId,
            data: JSON.stringify({ meds: { updatedAt: new Date(), list: data } })
          },
          requestConfig: {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'profile-key': MedicalHistoryEnums.profileKeys.PATIENTS,
              'route-key': MedicalHistoryEnums.routeKeys.UPDATE_ONE
            }
          }
        })

        resolve(response)
        message.success('General meds updated successfully')
      } catch (e) {
        reject(e)
      }
    })()
  })
}
export const updateFamMedHistory = (recordId, data) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      try {
        const response = await updateItemWithSync(STORES.MEDICAL_HISTORY, {
          _id: recordId,
          body: {
            recordId,
            data: JSON.stringify({ familyHistory: { updatedAt: new Date(), list: data } })
          },
          requestConfig: {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'profile-key': MedicalHistoryEnums.profileKeys.PATIENTS,
              'route-key': MedicalHistoryEnums.routeKeys.UPDATE_ONE
            }
          }
        })

        resolve(response)
        message.success('Family history updated successfully')
      } catch (e) {
        reject(e)
      }
    })()
  })
}

export const updateCovidInfo = (recordId, data) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      try {
        const response = await updateItemWithSync(STORES.MEDICAL_HISTORY, {
          _id: recordId,
          body: {
            recordId,
            data: JSON.stringify({ covidInfo: { ...data, updatedAt: new Date() } })
          },
          requestConfig: {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'profile-key': MedicalHistoryEnums.profileKeys.PATIENTS,
              'route-key': MedicalHistoryEnums.routeKeys.UPDATE_ONE
            }
          }
        })

        resolve(response)
        message.success('Covid info updated successfully')
      } catch (e) {
        reject(e)
      }
    })()
  })
}

export const updateLifestyle = (recordId, data) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      try {
        const response = await updateItemWithSync(STORES.MEDICAL_HISTORY, {
          _id: recordId,
          body: {
            recordId,
            data: JSON.stringify({ lifestyle: { ...data, updatedAt: new Date() } })
          },
          requestConfig: {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'profile-key': MedicalHistoryEnums.profileKeys.PATIENTS,
              'route-key': MedicalHistoryEnums.routeKeys.UPDATE_ONE
            }
          }
        })

        resolve(response)
        message.success('Lifestyle updated successfully')
      } catch (e) {
        reject(e)
      }
    })()
  })
}

export const updateSurgeries = (recordId, data) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      try {
        const response = await updateItemWithSync(STORES.MEDICAL_HISTORY, {
          _id: recordId,
          body: {
            recordId,
            data: JSON.stringify({ surgicalHistory: { updatedAt: new Date(), list: data } })
          },
          requestConfig: {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'profile-key': MedicalHistoryEnums.profileKeys.PATIENTS,
              'route-key': MedicalHistoryEnums.routeKeys.UPDATE_ONE
            }
          }
        })

        resolve(response)
        message.success('Surgical history updated successfully')
      } catch (e) {
        reject(e)
      }
    })()
  })
}

export const updateMentalHealth = (recordId, data) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      try {
        const response = await updateItemWithSync(STORES.MEDICAL_HISTORY, {
          _id: recordId,
          body: {
            recordId,
            data: JSON.stringify({ mentalHealth: { updatedAt: new Date(), list: data } })
          },
          requestConfig: {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'profile-key': MedicalHistoryEnums.profileKeys.PATIENTS,
              'route-key': MedicalHistoryEnums.routeKeys.UPDATE_ONE
            }
          }
        })

        resolve(response)
        message.success('Mental health updated successfully')
      } catch (e) {
        reject(e)
      }
    })()
  })
}
